import { useContext } from 'react';
import { WorkflowContext } from "../../../context/WorkflowContextProvider";
import {Handle, Position, useReactFlow } from "@xyflow/react";
import SettingsIcon from '@mui/icons-material/Settings';
import CheckIcon from "@mui/icons-material/Check";

function WorkflowSitemapNode({id, data}) {
    const context = useContext(WorkflowContext);
    const reactFlowInstance = useReactFlow();

    function handleSitemapConfigurationClick() {
        let node = reactFlowInstance.getNode(id);
        context.setActiveEditSitemapNode(node);
    }

    let url = data.url ?? '';
    if (url.length > 15) {
        url = url.substring(0, 15) + '...';
    }

    function successfulTest(): string {
        let returnValue: string = '';
        if (!!context.testComplete.includes(id)) {
            returnValue = ' test-success'
        }

        if (!!context.testProcessing.includes(id)) {
            returnValue = ' test-processing'
        }

        if (!!context.testErrored.includes(id)) {
            returnValue = ' test-error';
        }

        return returnValue;
    }

    return (
        <div className={ "workflow-node sitemap " + id + " " + (successfulTest()) }>
            { (successfulTest() !== '') &&
                <div className={ successfulTest() + "-icon" } />
            }
           <Handle type="target" id="sitemap-node-target" position={Position.Top} >
               <span className="handle-label top" >{ "Input" }</span>
           </Handle>
            <div className="node__layout sitemap">
                <div className="layout__top">
                    <span className="sitemap-icon" title="Scraper Node" />
                    <span className={ "label" }>
                        { 'URL: ' + url }
                    </span>
                </div>
                <div className="layout__bottom">
                    <span className={ "label-span" }>
                        { data.label }
                    </span>
                    <span className="action-span nodrag" onClick={ handleSitemapConfigurationClick }>
                        <SettingsIcon />
                    </span>
                </div>
            </div>
            <Handle type="source" id="sitemap-node-source" position={Position.Bottom} >
                <span className="handle-label bottom" >{ "Output" }</span>
            </Handle>
        </div>
    );
}

export default WorkflowSitemapNode;